import { colors } from './colors'
import { getColorOptions } from './utils'

export const palette = {
  blue: getColorOptions(colors.blue),
  lightBlue: getColorOptions(colors.blue),
  red: getColorOptions(colors.red),
  lightRed: getColorOptions(colors.red),
  green: getColorOptions(colors.green),
  lightGreen: getColorOptions(colors.green),
  yellow: getColorOptions(colors.yellow),
  lightYellow: getColorOptions(colors.yellow),
  gray: getColorOptions(colors.black),
}

export const fontWeights = {
  bold: 700,
  semiBold: 600,
  medium: 500,
  regular: 400,
}

export const boxShadows = {
  small: `0px 2px 2px -1px rgba(138, 148, 166, 0.13)`,
  medium: `0px 4px 5px -2px rgba(138, 148, 166, 0.13)`,
  large: `0px 6px 10px -1px rgba(138, 148, 166, 0.1)`,
}

export const backgrounds = {
  backgroundOne: colors.backgroundOne,
  backgroundTwo: colors.backgroundTwo,
  backgroundThree: colors.backgroundThree,
  backgroundFour: colors.backgroundFour,
  backgroundFive: colors.backgroundFive,
  backgroundSix: colors.backgroundSix,
}

export const typographyColors = {
  typographyOne: colors.typographyOne,
  typographyTwo: colors.typographyTwo,
  typographyThree: colors.typographyThree,
  typographyFour: colors.typographyFour,
  typographyFive: colors.typographyFive,
}

export const fonts = {
  family: {
    PlusJakartaSans: ['"Plus Jakarta Sans"', 'sans-serif'].join(','),
    OpenSans: ['"Open Sans"', 'sans-serif'].join(','),
    CambriaMath: ['"Cambria Math"', 'math', 'serif'].join(','),
  },
  weight: fontWeights,
}

export const typography = {
  fontSize: 14,
  htmlFontSize: 14,
  fontFamily: fonts.family.PlusJakartaSans,
  h1: {
    fontSize: 64,
    lineHeight: 1.25,
    fontWeight: fontWeights.bold,
    color: typographyColors.typographyTwo,
  },
  h2: {
    fontSize: 54,
    lineHeight: 1.25,
    fontWeight: fontWeights.bold,
    color: typographyColors.typographyTwo,
  },
  h3: {
    fontSize: 40,
    lineHeight: 1.25,
    fontWeight: fontWeights.bold,
    color: typographyColors.typographyTwo,
  },
  h4: {
    fontSize: 38,
    lineHeight: 1.25,
    fontWeight: fontWeights.bold,
    color: typographyColors.typographyTwo,
  },
  title1: {
    fontSize: 28,
    lineHeight: 1.25,
    color: typographyColors.typographyTwo,
  },
  title2: {
    fontSize: 24,
    lineHeight: 1.25,
    color: typographyColors.typographyTwo,
  },
  title3: {
    fontSize: 22,
    lineHeight: 1.25,
    color: typographyColors.typographyTwo,
  },
  title4: {
    fontSize: 20,
    lineHeight: 1.25,
    color: typographyColors.typographyTwo,
  },
  body1: {
    fontSize: 18,
    lineHeight: 1.25,
    color: typographyColors.typographyTwo,
  },
  body2: {
    fontSize: 16,
    lineHeight: 1.25,
    color: typographyColors.typographyTwo,
  },
  body3: {
    fontSize: 14,
    lineHeight: 1.25,
    color: typographyColors.typographyTwo,
  },
  small1: {
    fontSize: 12,
    lineHeight: 1.25,
    color: typographyColors.typographyTwo,
  },
}
